"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const SampleList_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/UI/SampleList.vue"));
const SamplesZero_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/UI/SamplesZero.vue"));
const SamplesLarge_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/UI/SamplesLarge.vue"));
const Loader_vue_1 = __importDefault(require("@becrop/components/Toolkit/Common/UI/Loader.vue"));
const Heatmap_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/models/Heatmap"));
const debounce_1 = require("@common/tsutils/debounce");
const UIMiniLoader_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/UI/UIMiniLoader.vue"));
const lucide_vue_next_1 = require("lucide-vue-next");
let PreSelectionArea = class PreSelectionArea extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.search = '';
        this.preselheight = 300;
    }
    mounted() {
        this.calculateHeight();
    }
    get preStatus() {
        if (!this.heatmap.loaded_samples)
            return 'loading';
        if (!this.heatmap.filtered_samples2)
            return 'loading';
        if (!this.heatmap.filteredLibrarySamples2.length)
            return 'zero';
        if (this.heatmap.filteredLibrarySamples2.length > Heatmap_1.default.PRE_MAX_SAMPLES)
            return 'large';
        return 'list';
    }
    calculateHeight() {
        //let maxRoom = window.innerHeight - 264 - 125 - 51;
        if (this.filopen) {
            let maxRoom = window.innerHeight - 264 - 125 - 15 - 51;
            this.preselheight = document.getElementsByClassName("presel__container")[0].getClientRects()[0].height;
            if (this.preselheight > maxRoom)
                this.preselheight = maxRoom - 30;
        }
        else {
            this.preselheight = document.getElementsByClassName("presel__container")[0].getClientRects()[0].height;
        }
    }
    clearSearch() {
        this.search = "";
    }
    checkAll() {
        const library2 = this.heatmap.filteredLibrarySamples2;
        if (library2.isAllSelected) {
            library2.unSelectAll();
        }
        else {
            library2.selectAll();
        }
    }
    get num_selected_samples() {
        if (!this.heatmap.filtered_samples2)
            return null;
        const total = this.heatmap.librarySamples.length;
        const filtered = this.heatmap.filteredLibrarySamples2.length;
        if (total === filtered) {
            return total;
        }
        else {
            return `${filtered}/${total}`;
        }
    }
    onFilChangeDisplay() {
        this.calculateHeight();
    }
    onFilChangeNum() {
        this.calculateHeight();
    }
    onSearch() {
        this.onSearch2();
    }
    onSearch2() {
        this.heatmap.filterLibraryText(this.search);
    }
    onChangeFilter() {
        this.search = '';
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], PreSelectionArea.prototype, "heatmap", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], PreSelectionArea.prototype, "filopen", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], PreSelectionArea.prototype, "nf", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('filopen')
], PreSelectionArea.prototype, "onFilChangeDisplay", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('nf')
], PreSelectionArea.prototype, "onFilChangeNum", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('search')
], PreSelectionArea.prototype, "onSearch", null);
__decorate([
    (0, debounce_1.Debounce)(500)
], PreSelectionArea.prototype, "onSearch2", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('heatmap.filtered_samples')
], PreSelectionArea.prototype, "onChangeFilter", null);
PreSelectionArea = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            SampleList: SampleList_vue_1.default,
            SamplesZero: SamplesZero_vue_1.default,
            SamplesLarge: SamplesLarge_vue_1.default,
            Loader: Loader_vue_1.default,
            UIMiniLoader: UIMiniLoader_vue_1.default,
            X: lucide_vue_next_1.X
        }
    })
], PreSelectionArea);
exports.default = PreSelectionArea;
